import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useStore = defineStore('main', () => {
  const windowWidth = ref(window.innerWidth)
  const windowHeight = ref(window.innerHeight)
  const splashText = ref<string>('')
  const property = ref<Property | null>(null);
  const stays = ref<Stay[]>([]) as Ref<Stay[]>;
  const imagesList = ref<string[]>([])
  const currentBookings = ref<Booking[] | null>(null);

  const isPro = ref(true);
  const loading = ref(true);
  const bookingDraft = ref<BookingDraft | null>(null);
const booking = ref<Booking | null>(null);


  const venueName = computed(() => property.value?.name || '');

  const mapEmbedSource = computed(() => {

    let place = venueName.value +
      (property.value?.address ? ", " + property.value.address : "") +
      (property.value?.city ? ", " + property.value.city : "") +
      (property.value?.state ? ", " + property.value.state : "") +
      (property.value?.postcode ? ", " + property.value.postcode : "");
    return `https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(place)}`;
  })

  const heroImage = computed(() => {
    const image = imagesList.value.find(img => img.startsWith(`${property.value?.tag}/hero/`));
    if(image) return {
      src: import.meta.env.VITE_ASSETS_HOST + image,
      thumbnail: import.meta.env.VITE_THUMBNAILS_HOST + webpName(image),
      alt: "Hero Image"
    }
    else return null;
  })

  const aboutImage = computed(() => {
    const image = imagesList.value.find(img => img.startsWith(`${property.value?.tag}/about/`));
    if(image) return {
      src: import.meta.env.VITE_ASSETS_HOST + image,
      thumbnail: import.meta.env.VITE_THUMBNAILS_HOST + webpName(image),
      alt: "About Image"
    }
    else return null;
  })

  const exteriorImages = computed(() => {
    const images = imagesList.value.filter(img => img.startsWith(`${property.value?.tag}/exterior/`));
    return images.map((img, index) => ({
      src: import.meta.env.VITE_ASSETS_HOST + img,
      thumbnail: import.meta.env.VITE_THUMBNAILS_HOST + webpName(img),
      alt: "Exterior Image" + (index + 1)
    }));
  })

  const surroundingsImages = computed(() => {
    const images = imagesList.value.filter(img => img.startsWith(`${property.value?.tag}/surroundings/`));
    return images.map((img, index) => ({
      src: import.meta.env.VITE_ASSETS_HOST + img,
      thumbnail: import.meta.env.VITE_THUMBNAILS_HOST + webpName(img),
      alt: "Surroundings Image" + (index + 1)
    }));
  })

  const otherImages = computed(() => {
    const images = imagesList.value.filter(img => img.startsWith(`${property.value?.tag}/other/`));
    return images.map((img, index) => ({
      src: import.meta.env.VITE_ASSETS_HOST + img,
      thumbnail: import.meta.env.VITE_THUMBNAILS_HOST + webpName(img),
      alt: "Other Image" + (index + 1)
    }));
  })


  function setWindowSize() {
    windowWidth.value = window.innerWidth;
    windowHeight.value = window.innerHeight;
  }


  async function fetchSiteData() {
    let url = import.meta.env.VITE_API_HOST + '/site';
    try {
      const response = await fetch(url);
      console.log(response.status);
      if (response.ok) {
        let result = await response.json();
        
        if (result && result.data && result.imagesList) {
          const data = JSON.parse(result.data)
          property.value = data.property
          stays.value = data.stays || []
          currentBookings.value = data.bookings || []
          imagesList.value = result.imagesList || []
          loading.value = false;
          if(property.value && property.value.name) {
            const title = document.getElementById('app-title');
            if(title) title.innerText = property.value.name;
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  function setCurrentBookings(bookings: Booking[]) {
    currentBookings.value = bookings;
  }

  function getTariff(stayName: string) {
    //ToDo: implement
    return 10000;
  }

  async function makeBooking(booking: Booking) {

    let url = import.meta.env.VITE_API_HOST + '/booking';
    try {
      const response = await fetch(url);
      console.log(response.status);
      if (response.ok) {

      }
    } catch (e) {

    }
  }


  return {
    windowWidth,
    windowHeight,
    splashText,
    property,
    stays,
    currentBookings,
    imagesList,


    bookingDraft,
    booking,
    isPro,
    loading,
    

    //computes
    venueName,
    mapEmbedSource,
    heroImage,
    aboutImage,
    exteriorImages,
    surroundingsImages,
    otherImages,




    //actions
    setWindowSize,
    fetchSiteData,
    setBooking: (r: Booking) => booking.value = r,
    clearBooking: () => booking.value = null,
    getTariff,
    // getStayImages,
    // getStayThumbnails,    
    setBookingDraft: (r: BookingDraft) => bookingDraft.value = r,
    clearBookingDraft: () => bookingDraft.value = null,
    setCurrentBookings: (r: Booking[]) => currentBookings.value = r,
  }
})
